import React, { useState } from 'react';
import { useEffect } from 'react';
import { Container, Row } from 'reactstrap';
import Buttons from '../Constans/Buttons';
import PickUpCenterInformation from './PickUpCenterInformation';
import { isMobile } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { getHebrewDayName, getHebrewMonth } from '../../../../utilities/dateUtils';
function DeliveryDateStepTwo(props) {
    const [data, setData] = useState(null);
    const [selectedDay, setSelectedDay] = useState(null);
    const [selectedHours, setSelectedHours] = useState(null);
    const [startIndex, setStartIndex] = useState(0);
    const store = props.idfStore;
    const { cityName: city, streetName: street, home: homeNum } = store?.deliverySelectedAddress ? store.deliverySelectedAddress : {};

    useEffect(() => {
        if (store.deliveryMode === 'PICKUP') {
            return;
        }
        if (!city && !street && !street) {
            props.setDeliveryDateStep(1);
        }

        //props.saveToHistory('DeliveryDateStepTwo');
        getDeliverySlots();
    }, []);
    const getDeliverySlots = async () => {
        try {
            const res = await props.GetDeliverySlotsByAdress({ city: city, street: street, homeNum: homeNum });
            if (res?.payload?.errorCode == 1200) {
            }
            setData(res.payload);
        } catch (error) {
            console.log(error);
        } finally {
        }
    };

    const onContinueClick = () => {
        if (store.deliveryMode === 'DELIVERY') {
            if (selectedDay != null && selectedHours != null) {
                props.setDeliverySlot({
                    selectedHours,
                    date: selectedDay.date,
                    hebrewDayName: selectedDay.hebDay,
                    deliveryLocationId: selectedDay.slots[0].pickLocation,
                });

            }
        }
        return true;
    };

    const itemsPerPage = 3;
    const endIndex = startIndex + itemsPerPage;
    let displayedDates;
    if (data != null && data.length) displayedDates = data?.slice(startIndex, endIndex);

    const DateSlot = ({ dateObj }) => {
        const dateParts = dateObj.date.split('-');
        const year = parseInt(dateParts[0]);
        const month = parseInt(dateParts[1]) - 1;
        const day = parseInt(dateParts[2]);
        const hebrewDayName = getHebrewDayName(dateObj.date);
        const hebrewMonthName = getHebrewMonth(dateObj.date);
        return (
            <div
                className={`date-slot ${dateObj === selectedDay ? 'selected' : ''}`}
                onClick={() => {
                    setSelectedDay(dateObj);
                    if (dateObj != selectedDay) setSelectedHours(null);
                }}>
                <div className='month-title'>{hebrewMonthName}</div>
                <div className='date-number'>{day}</div>
                <div className='date-title'> {hebrewDayName}</div>
            </div>
        );
    };

    const displayFirstDate = (date) => {
        const inputDate = new Date(date);
        const day = inputDate.getDate();
        const month = inputDate.getMonth() + 1; // Months are zero-based
        const year = inputDate.getFullYear() % 100; // Extract the last two digits of the year
        const outputDateString = `${day}.${month}.${year}`;
        return outputDateString;
    };
    const HourSlot = ({ slot }) => {
        return (
            <div className={`hours-slot ${slot === selectedHours ? 'selected' : ''}`} onClick={() => setSelectedHours(slot)}>
                בין {slot.startHour.substring(0, 5)} - {slot.endHour.substring(0, 5)}
            </div>
        );
    };
    const Arrow = ({ mode }) => {
        if (mode)
            return (
                <span
                    className='arrow left'
                    onClick={() => {
                        if (startIndex + itemsPerPage < data.length) {
                            setStartIndex(startIndex + itemsPerPage);
                        }
                    }}>
                    {endIndex >= data.length ? (
                        // svg disable
                        <svg
                            style={{ transform: 'rotate(180deg)' }}
                            width='52'
                            height='52'
                            viewBox='0 0 52 52'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'>
                            <g filter='url(#lp553qmena)'>
                                <circle cx='26' cy='26' r='16' transform='rotate(-360 26 26)' fill='#F2F2F2' />
                            </g>
                            <path
                                d='M23.469 21.328a.729.729 0 0 1-.03-.976.607.607 0 0 1 .843-.087l.062.055 5.12 5.177a.73.73 0 0 1 .054.946l-.054.061-5.12 5.176a.608.608 0 0 1-.904-.031.731.731 0 0 1-.026-.912l.055-.063L28.09 26l-4.622-4.672z'
                                fill='#C6C6C6'
                                stroke='#C6C6C6'
                            />
                            <defs>
                                <filter id='lp553qmena' x='0' y='0' width='52' height='52' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'>
                                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                                    <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation='5' />
                                    <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.170837 0' />
                                    <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_1462_15171' />
                                    <feBlend in='SourceGraphic' in2='effect1_dropShadow_1462_15171' result='shape' />
                                </filter>
                            </defs>
                        </svg>
                    ) : (
                        // svg enable
                        <svg width='52' height='52' viewBox='0 0 52 52' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <g filter='url(#bg9hpw0j2a)'>
                                <circle cx='26' cy='26' r='16' transform='rotate(-180 26 26)' fill='#fff' />
                            </g>
                            <path
                                d='M28.465 30.672c.257.261.27.698.029.976a.607.607 0 0 1-.843.087l-.062-.055-5.12-5.177a.73.73 0 0 1-.054-.946l.054-.061 5.12-5.176a.608.608 0 0 1 .905.031c.223.257.229.649.026.912l-.055.063L23.841 26l4.623 4.672z'
                                fill='var(--theme-primary, #810ea9)'
                                stroke='var(--theme-primary, #810ea9)'
                            />
                            <defs>
                                <filter id='bg9hpw0j2a' x='0' y='0' width='52' height='52' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'>
                                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                                    <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation='5' />
                                    <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.170837 0' />
                                    <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_1462_15165' />
                                    <feBlend in='SourceGraphic' in2='effect1_dropShadow_1462_15165' result='shape' />
                                </filter>
                            </defs>
                        </svg>
                    )}
                </span>
            );
        else
            return (
                <span
                    className='arrow right'
                    onClick={() => {
                        if (startIndex > 0) {
                            setStartIndex(startIndex - itemsPerPage);
                        }
                    }}>
                    {startIndex != 0 ? (
                        // svg enable
                        <svg
                            style={{ transform: 'rotate(-180deg)' }}
                            width='52'
                            height='52'
                            viewBox='0 0 52 52'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'>
                            <g filter='url(#bg9hpw0j2a)'>
                                <circle cx='26' cy='26' r='16' transform='rotate(-180 26 26)' fill='#fff' />
                            </g>
                            <path
                                d='M28.465 30.672c.257.261.27.698.029.976a.607.607 0 0 1-.843.087l-.062-.055-5.12-5.177a.73.73 0 0 1-.054-.946l.054-.061 5.12-5.176a.608.608 0 0 1 .905.031c.223.257.229.649.026.912l-.055.063L23.841 26l4.623 4.672z'
                                fill='var(--theme-primary, #810ea9)'
                                stroke='var(--theme-primary, #810ea9)'
                            />
                            <defs>
                                <filter id='bg9hpw0j2a' x='0' y='0' width='52' height='52' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'>
                                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                                    <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation='5' />
                                    <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.170837 0' />
                                    <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_1462_15165' />
                                    <feBlend in='SourceGraphic' in2='effect1_dropShadow_1462_15165' result='shape' />
                                </filter>
                            </defs>
                        </svg>
                    ) : (
                        // svg disable
                        <svg width='52' height='52' viewBox='0 0 52 52' fill='none' xmlns='http://www.w3.org/2000/svg'>
                            <g filter='url(#lp553qmena)'>
                                <circle cx='26' cy='26' r='16' transform='rotate(-180 26 26)' fill='#F2F2F2' />
                            </g>
                            <path
                                d='M23.469 21.328a.729.729 0 0 1-.03-.976.607.607 0 0 1 .843-.087l.062.055 5.12 5.177a.73.73 0 0 1 .054.946l-.054.061-5.12 5.176a.608.608 0 0 1-.904-.031.731.731 0 0 1-.026-.912l.055-.063L28.09 26l-4.622-4.672z'
                                fill='#C6C6C6'
                                stroke='#C6C6C6'
                            />
                            <defs>
                                <filter id='lp553qmena' x='0' y='0' width='52' height='52' filterUnits='userSpaceOnUse' color-interpolation-filters='sRGB'>
                                    <feFlood flood-opacity='0' result='BackgroundImageFix' />
                                    <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
                                    <feOffset />
                                    <feGaussianBlur stdDeviation='5' />
                                    <feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.170837 0' />
                                    <feBlend in2='BackgroundImageFix' result='effect1_dropShadow_1462_15171' />
                                    <feBlend in='SourceGraphic' in2='effect1_dropShadow_1462_15171' result='shape' />
                                </filter>
                            </defs>
                        </svg>
                    )}
                </span>
            );
    };
    return (
        <div className='delivery-date-main step'>
            <div className='delivery-date-step-two step'>
                {store.deliveryMode !== 'PICKUP' ? (
                    <>
                        {' '}
                        {data && (
                            <>
                                {' '}
                                <Container fluid className='idf-step-header justify-content-center d-flex flex-column align-items-center'>
                                    <Row className='idf-title-bold justify-content-center d-flex'>{props.contentData.deliveryTitle.value}</Row>
                                    <Row className='idf-line justify-content-center d-flex'></Row>
                                </Container>
                                <div className='d-flex justify-content-center align-items-center flex-column text-wrap text-container '>
                                    <Row className='idf-sub-title-bold  justify-content-center d-flex'>בחרו את היום והשעה הנוחים לכם</Row>
                                    <Row className='idf-sub-title d-flex text-center align-items-center justify-content-center w-100'>{`נוכל להגיע לכתובת ${street + ' ' + homeNum}, ${city}  ${getHebrewDayName(data[0].date)} ${displayFirstDate(data[0].date)}`}</Row>
                                    {/* <Row className='d-flex justify-content-center align-items-center'>
                  <div className='idf-description-bold'>כתובת למשלוח: </div>
                  <div className='idf-sub-title mr-1'>{street + ' ' + homeNum + ', ' + city}</div>
                </Row> */}
                            </div>
                            <div className='mt-2 date-slot-container'>
                                {isMobile ? (
                                    <>
                                        <Swiper
                                            spaceBetween={2}
                                            // centeredSlides
                                            slidesPerView={displayedDates.length > 1 ? 2.5 : 1}
                                            pagination={false}
                                            // pagination={{clickable: true}}
                                            className='d-block d-md-none'
                                            style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                                            {displayedDates?.map((element, i) => (
                                                <SwiperSlide key={i}>
                                                    {' '}
                                                    <DateSlot dateObj={element} />
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </>
                                ) : (
                                    <>
                                        <Arrow mode={false} />
                                        {displayedDates && displayedDates.map((el) => <DateSlot dateObj={el} />)}
                                        <Arrow mode={true} />
                                    </>
                                )}
                            </div>
                            <div className='hour-slot-container'>{selectedDay && selectedDay.slots.map((slot) => <HourSlot slot={slot} />)}</div>
                        </>
                    )}
                </>
            ) : (
                <PickUpCenterInformation store={store} />
            )}

                <Buttons
                    onClickNavigation={onContinueClick}
                    canContinue={store.deliveryMode === 'PICKUP' ? true : selectedHours != null && selectedDay != null}
                />
            </div>
        </div>
    );
}

export default DeliveryDateStepTwo;
